<div class="flex" *ngIf="loading">
  <div style="margin-top: 16px">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                       animationDuration=".5s"></p-progressSpinner>
  </div>
</div>

<div *ngIf="preServiceChecklist.length > 0 || mandatoryChecklist.length > 0 || mandatoryBlockersChecklist.length > 0">
  <div class="details-container">
    <div *ngIf="preServiceChecklist.length > 0">
      <div class="checklist-container-header">
        {{
        'bikeshop.modal.update_job_card.checklist.pre_service_checklist' |
          translate
        }}
      </div>
      <div class="vertical-checklist">
        <div *ngFor="let checklistItem of preServiceChecklist">
          <div>
            <div class="checklist-label" [ngStyle]="{ 'color': checklistItem.labelColour }">
              {{checklistItem.description}}
            </div>
            <div *ngIf="!checklistItem.frontRearCheck">
              <div *ngIf="checklistItem.controlType === 'CHECKBOX'">
                <p-checkbox [(ngModel)]="checklistItem.defaultValue" [binary]="true"
                            (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
              </div>
              <div *ngIf="checklistItem.controlType === 'TEXT'">
                <input type="text" pInputText [(ngModel)]="checklistItem.defaultValue"
                       (blur)="updateChecklistItem(checklistItem)"
                       style="width:100%; word-break:break-word;" />
              </div>
              <div *ngIf="checklistItem.controlType === 'MULTILINETEXT'">
                <textarea type="text" pInputText [(ngModel)]="checklistItem.defaultValue" rows="5"
                          (blur)="updateChecklistItem(checklistItem)"
                          style="width:100%; word-break:break-word;"></textarea>
              </div>
              <div *ngIf="checklistItem.controlType === 'RADIO'">
                <div>
                  <p-radioButton name="{{checklistItem.description}}"
                                 value="{{'general.yes' | translate}}"
                                 label="{{('general.yes' | translate).substring(0,1)}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 labelStyleClass="p-radiobutton-label-override"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}"
                                 value="{{'general.no' | translate}}"
                                 label="{{('general.no' | translate).substring(0,1)}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 labelStyleClass="p-radiobutton-label-override"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}"
                                 value="{{'general.not_applicable' | translate}}"
                                 label="NA" [(ngModel)]="checklistItem.defaultValue"
                                 labelStyleClass="p-radiobutton-label-override"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                </div>
              </div> 
              <div *ngIf="checklistItem.controlType === 'TRAFFICLIGHT'">
                <div class="radio-group">
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.yes' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="red-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.no' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="yellow-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.not_applicable' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="green-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>

                  <input type="text" pInputText [(ngModel)]="checklistItem.frontValue" maxlength="1500" style="max-width:163px;min-width:163px"
                         (blur)="updateChecklistItem(checklistItem)" />

                </div>
              </div>

            </div>
            <div *ngIf="checklistItem.frontRearCheck">
              <div *ngIf="checklistItem.controlType === 'CHECKBOX'" class="front-rear-check">
                <span>F</span>
                <p-checkbox [(ngModel)]="checklistItem.frontValue" [binary]="true"
                            (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
                <span>R</span>
                <p-checkbox [(ngModel)]="checklistItem.rearValue" [binary]="true"
                            (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
              </div>
              <div *ngIf="checklistItem.controlType === 'TEXT'" class="front-rear-check">
                <span>F</span>
                <input type="text" pInputText [(ngModel)]="checklistItem.frontValue"
                       (blur)="updateChecklistItem(checklistItem)" style="width:40% !important" />
                <span>R</span>
                <input type="text" pInputText [(ngModel)]="checklistItem.rearValue"
                       (blur)="updateChecklistItem(checklistItem)" style="width:40% !important" />
              </div>
              <div *ngIf="checklistItem.controlType === 'MULTILINETEXT'" class="front-rear-check">
                <span>F</span>
                <textarea type="text" pInputText [(ngModel)]="checklistItem.frontValue" rows="5"
                          (blur)="updateChecklistItem(checklistItem)"
                          style="width:40% !important; word-break:break-word;"></textarea>
                <span>R</span>
                <textarea type="text" pInputText [(ngModel)]="checklistItem.rearValue" rows="5"
                          (blur)="updateChecklistItem(checklistItem)"
                          style="width:40% !important; word-break:break-word;"></textarea>
              </div>
              <div *ngIf="checklistItem.controlType === 'RADIO'" class="front-rear-check">
                <span>F</span>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.yes' | translate}}"
                               label="{{('general.yes' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.frontValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.no' | translate}}"
                               label="{{('general.no' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.frontValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.not_applicable' | translate}}"
                               label="NA" [(ngModel)]="checklistItem.frontValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <br />
                <span>R</span>
                <p-radioButton name="{{checklistItem.description}}_R"
                               value="{{'general.yes' | translate}}"
                               label="{{('general.yes' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.rearValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_R"
                               value="{{'general.no' | translate}}"
                               label="{{('general.no' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.rearValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_R"
                               value="{{'general.not_applicable' | translate}}"
                               label="NA" [(ngModel)]="checklistItem.rearValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
              </div>
              <div *ngIf="checklistItem.controlType === 'TRAFFICLIGHT'" class="front-rear-check">
                <div class="radio-group">


                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.yes' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="red-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.no' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="yellow-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.not_applicable' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="green-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>



                  <span style="padding-top:2%">F</span>
                  <input type="text" pInputText [(ngModel)]="checklistItem.frontValue" maxlength="1500"
                         (blur)="updateChecklistItem(checklistItem)" />

                  <span style="padding-top:2%">R</span>
                  <input type="text" pInputText [(ngModel)]="checklistItem.rearValue" maxlength="1500"
                         (blur)="updateChecklistItem(checklistItem)" />

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="mandatoryChecklist.length > 0">
      <div class="checklist-container-header">
        {{
        'bikeshop.checklist.all_services_checklist' | translate
        }}
      </div>
      <div class="vertical-checklist">
        <div *ngFor="let checklistItem of mandatoryChecklist">
          <div>
            <div class="checklist-label" [ngStyle]="{ 'color': checklistItem.labelColour }">
              {{checklistItem.description}}
            </div>
            <div *ngIf="!checklistItem.frontRearCheck">
              <div *ngIf="checklistItem.controlType === 'CHECKBOX'">
                <p-checkbox [(ngModel)]="checklistItem.defaultValue" [binary]="true"
                            (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
              </div>
              <div *ngIf="checklistItem.controlType === 'TEXT'">
                <input type="text" pInputText [(ngModel)]="checklistItem.defaultValue"
                       (blur)="updateChecklistItem(checklistItem)" style="width:100%" />
              </div>
              <div *ngIf="checklistItem.controlType === 'MULTILINETEXT'">
                <textarea type="text" pInputText [(ngModel)]="checklistItem.defaultValue" rows="5"
                          (blur)="updateChecklistItem(checklistItem)"
                          style="width:100%; word-break:break-word;"></textarea>
              </div>
              <div *ngIf="checklistItem.controlType === 'RADIO'">
                <div>
                  <p-radioButton name="{{checklistItem.description}}"
                                 value="{{'general.yes' | translate}}"
                                 label="{{('general.yes' | translate).substring(0,1)}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 labelStyleClass="p-radiobutton-label-override"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}"
                                 value="{{'general.no' | translate}}"
                                 label="{{('general.no' | translate).substring(0,1)}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 labelStyleClass="p-radiobutton-label-override"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}"
                                 value="{{'general.not_applicable' | translate}}"
                                 label="NA" [(ngModel)]="checklistItem.defaultValue"
                                 labelStyleClass="p-radiobutton-label-override"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                </div>
              </div>
              <div *ngIf="checklistItem.controlType === 'TRAFFICLIGHT'">
                <div class="radio-group">
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.yes' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="red-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.no' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="yellow-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.not_applicable' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="green-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>

                  <input type="text" pInputText [(ngModel)]="checklistItem.frontValue" maxlength="1500" style="max-width:163px;min-width:163px"
                         (blur)="updateChecklistItem(checklistItem)" />

                </div>
              </div>
            </div>
            <div *ngIf="checklistItem.frontRearCheck">
              <div *ngIf="checklistItem.controlType === 'CHECKBOX'" class="front-rear-check">
                <span>F</span>
                <p-checkbox [(ngModel)]="checklistItem.frontValue" [binary]="true"
                            (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
                <span>R</span>
                <p-checkbox [(ngModel)]="checklistItem.rearValue" [binary]="true"
                            (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
              </div>
              <div *ngIf="checklistItem.controlType === 'TEXT'" class="front-rear-check">
                <span>F</span>
                <input type="text" pInputText [(ngModel)]="checklistItem.frontValue"
                       (blur)="updateChecklistItem(checklistItem)" style="width:40% !important" />
                <span>R</span>
                <input type="text" pInputText [(ngModel)]="checklistItem.rearValue"
                       (blur)="updateChecklistItem(checklistItem)" style="width:40% !important;" />
              </div>
              <div *ngIf="checklistItem.controlType === 'MULTILINETEXT'" class="front-rear-check">
                <span>F</span>
                <textarea type="text" pInputText [(ngModel)]="checklistItem.frontValue" rows="5"
                          (blur)="updateChecklistItem(checklistItem)"
                          style="width:40% !important; word-break:break-word;"></textarea>
                <span>R</span>
                <textarea type="text" pInputText [(ngModel)]="checklistItem.rearValue" rows="5"
                          (blur)="updateChecklistItem(checklistItem)"
                          style="width:40%!important; word-break:break-word;"></textarea>
              </div>
              <div *ngIf="checklistItem.controlType === 'RADIO'" class="front-rear-check">
                <span>F</span>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.yes' | translate}}"
                               label="{{('general.yes' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.frontValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.no' | translate}}"
                               label="{{('general.no' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.frontValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.not_applicable' | translate}}"
                               label="NA" [(ngModel)]="checklistItem.frontValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <br />
                <span>R</span>
                <p-radioButton name="{{checklistItem.description}}_R"
                               value="{{'general.yes' | translate}}"
                               label="{{('general.yes' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.rearValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_R"
                               value="{{'general.no' | translate}}"
                               label="{{('general.no' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.rearValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_R"
                               value="{{'general.not_applicable' | translate}}"
                               label="NA" [(ngModel)]="checklistItem.rearValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
              </div>
              <div *ngIf="checklistItem.controlType === 'TRAFFICLIGHT'" class="front-rear-check">
                <div class="radio-group">


                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.yes' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="red-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.no' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="yellow-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.not_applicable' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="green-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>



                  <span style="padding-top:2%">F</span>
                  <input type="text" pInputText [(ngModel)]="checklistItem.frontValue" maxlength="1500"
                         (blur)="updateChecklistItem(checklistItem)" />

                  <span style="padding-top:2%">R</span>
                  <input type="text" pInputText [(ngModel)]="checklistItem.rearValue" maxlength="1500"
                         (blur)="updateChecklistItem(checklistItem)" />

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="mandatoryBlockersChecklist.length > 0">

      <div class="checklist-container-header">
        {{
        'bikeshop.modal.update_job_card.checklist.mandatory_list' | translate
        }}
      </div>
      <div class="vertical-checklist">
        <div *ngFor="let checklistItem of mandatoryBlockersChecklist">
          <div>
            <div class="checklist-label" [ngStyle]="{ 'color': checklistItem.labelColour }">
              {{checklistItem.description}}
            </div>
            <div *ngIf="!checklistItem.frontRearCheck">
              <div *ngIf="checklistItem.controlType === 'CHECKBOX'">
                <p-checkbox [(ngModel)]="checklistItem.defaultValue" [binary]="true"
                            (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
              </div>
              <div *ngIf="checklistItem.controlType === 'TEXT'">
                <input type="text" pInputText [(ngModel)]="checklistItem.defaultValue"
                       (blur)="updateChecklistItem(checklistItem)" style="width:100%" />
              </div>
              <div *ngIf="checklistItem.controlType === 'MULTILINETEXT'">
                <textarea type="text" pInputText [(ngModel)]="checklistItem.defaultValue" rows="5"
                          (blur)="updateChecklistItem(checklistItem)"
                          style="width:100%; word-break:break-word;"></textarea>
              </div>
              <div *ngIf="checklistItem.controlType === 'RADIO'">
                <div>
                  <p-radioButton name="{{checklistItem.description}}"
                                 value="{{'general.yes' | translate}}"
                                 label="{{('general.yes' | translate).substring(0,1)}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 labelStyleClass="p-radiobutton-label-override"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}"
                                 value="{{'general.no' | translate}}"
                                 label="{{('general.no' | translate).substring(0,1)}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 labelStyleClass="p-radiobutton-label-override"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}"
                                 value="{{'general.not_applicable' | translate}}"
                                 label="NA" [(ngModel)]="checklistItem.defaultValue"
                                 labelStyleClass="p-radiobutton-label-override"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                </div>
              </div>
              <div *ngIf="checklistItem.controlType === 'TRAFFICLIGHT'">
                <div class="radio-group">
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.yes' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="red-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.no' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="yellow-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.not_applicable' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="green-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>

                  <input type="text" pInputText [(ngModel)]="checklistItem.frontValue" maxlength="1500" style="max-width:163px;min-width:163px"
                         (blur)="updateChecklistItem(checklistItem)" />

                </div>
              </div>
            </div>
            <div *ngIf="checklistItem.frontRearCheck">
              <div *ngIf="checklistItem.controlType === 'CHECKBOX'" class="front-rear-check">
                <span>F</span>
                <p-checkbox [(ngModel)]="checklistItem.frontValue" [binary]="true"
                            (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
                <span>R</span>
                <p-checkbox [(ngModel)]="checklistItem.rearValue" [binary]="true"
                            (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
              </div>
              <div *ngIf="checklistItem.controlType === 'TEXT'" class="front-rear-check">
                <span>F</span>
                <input type="text" pInputText [(ngModel)]="checklistItem.frontValue"
                       (blur)="updateChecklistItem(checklistItem)" style="width:40% !important" />
                <span>R</span>
                <input type="text" pInputText [(ngModel)]="checklistItem.rearValue"
                       (blur)="updateChecklistItem(checklistItem)" style="width:40% !important" />
              </div>
              <div *ngIf="checklistItem.controlType === 'MULTILINETEXT'" class="front-rear-check">
                <span>F</span>
                <textarea type="text" pInputText [(ngModel)]="checklistItem.frontValue" rows="5"
                          (blur)="updateChecklistItem(checklistItem)"
                          style="width:40% !important; word-break:break-word;"></textarea>
                <span>R</span>
                <textarea type="text" pInputText [(ngModel)]="checklistItem.rearValue" rows="5"
                          (blur)="updateChecklistItem(checklistItem)"
                          style="width:40% !important; word-break:break-word;"></textarea>
              </div>
              <div *ngIf="checklistItem.controlType === 'RADIO'" class="front-rear-check">
                <span>F</span>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.yes' | translate}}"
                               label="{{('general.yes' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.frontValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.no' | translate}}"
                               label="{{('general.no' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.frontValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.not_applicable' | translate}}"
                               label="NA" [(ngModel)]="checklistItem.frontValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <br />
                <span>R</span>
                <p-radioButton name="{{checklistItem.description}}_R"
                               value="{{'general.yes' | translate}}"
                               label="{{('general.yes' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.rearValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_R"
                               value="{{'general.no' | translate}}"
                               label="{{('general.no' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.rearValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_R"
                               value="{{'general.not_applicable' | translate}}"
                               label="NA" [(ngModel)]="checklistItem.rearValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
              </div>
              <div *ngIf="checklistItem.controlType === 'TRAFFICLIGHT'" class="front-rear-check">
                <div class="radio-group">


                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.yes' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="red-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.no' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="yellow-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.not_applicable' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="green-border"
                                 (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>



                  <span style="padding-top:2%">F</span>
                  <input type="text" pInputText [(ngModel)]="checklistItem.frontValue" maxlength="1500"
                         (blur)="updateChecklistItem(checklistItem)" />

                  <span style="padding-top:2%">R</span>
                  <input type="text" pInputText [(ngModel)]="checklistItem.rearValue" maxlength="1500"
                         (blur)="updateChecklistItem(checklistItem)" />

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="details-container margin-top-8" *ngIf="linkedServiceChecklist.length > 0">
  <div>
    <div class="checklist-container-header">
      {{
      'bikeshop.modal.update_job_card.checklist.linked_service_checklist' |
        translate
      }}
    </div>
    <div class="vertical-checklist">
      <div *ngFor="let checklistItem of linkedServiceChecklist">
        <div>
          <div class="checklist-label" [ngStyle]="{ 'color': checklistItem.labelColour }">
            {{checklistItem.description}}
          </div>
          <div *ngIf="!checklistItem.frontRearCheck">
            <div *ngIf="checklistItem.controlType === 'CHECKBOX'">
              <p-checkbox [(ngModel)]="checklistItem.defaultValue" [binary]="true"
                          (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
            </div>
            <div *ngIf="checklistItem.controlType === 'TEXT'">
              <input type="text" pInputText [(ngModel)]="checklistItem.defaultValue"
                     (blur)="updateChecklistItem(checklistItem)" style="width:100%" />
            </div>
            <div *ngIf="checklistItem.controlType === 'MULTILINETEXT'">
              <textarea type="text" pInputText [(ngModel)]="checklistItem.defaultValue" rows="5"
                        (blur)="updateChecklistItem(checklistItem)"
                        style="width:100%; word-break:break-word;"></textarea>
            </div>
            <div *ngIf="checklistItem.controlType === 'RADIO'">
              <div>
                <p-radioButton name="{{checklistItem.description}}"
                               value="{{'general.yes' | translate}}"
                               label="{{('general.yes' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}" value="{{'general.no' | translate}}"
                               label="{{('general.no' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}"
                               value="{{'general.not_applicable' | translate}}"
                               label="NA" [(ngModel)]="checklistItem.defaultValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
              </div>
            </div>
            <div *ngIf="checklistItem.controlType === 'TRAFFICLIGHT'">
              <div class="radio-group">
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.yes' | translate}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               styleClass="red-border"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.no' | translate}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               styleClass="yellow-border"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.not_applicable' | translate}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               styleClass="green-border"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>

                <input type="text" pInputText [(ngModel)]="checklistItem.frontValue" maxlength="1500" style="max-width:163px;min-width:163px"
                       (blur)="updateChecklistItem(checklistItem)" />

              </div>
            </div>
          </div>
          <div *ngIf="checklistItem.frontRearCheck">
            <div *ngIf="checklistItem.controlType === 'CHECKBOX'" class="front-rear-check">
              <span>F</span>
              <p-checkbox [(ngModel)]="checklistItem.frontValue" [binary]="true"
                          (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
              <span>R</span>
              <p-checkbox [(ngModel)]="checklistItem.rearValue" [binary]="true"
                          (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
            </div>
            <div *ngIf="checklistItem.controlType === 'TEXT'" class="front-rear-check">
              <span>F</span>
              <input type="text" pInputText [(ngModel)]="checklistItem.frontValue"
                     (blur)="updateChecklistItem(checklistItem)" style="width:40% !important" />
              <span>R</span>
              <input type="text" pInputText [(ngModel)]="checklistItem.rearValue"
                     (blur)="updateChecklistItem(checklistItem)" style="width:40% !important" />
            </div>
            <div *ngIf="checklistItem.controlType === 'MULTILINETEXT'" class="front-rear-check">
              <span>F</span>
              <textarea type="text" pInputText [(ngModel)]="checklistItem.frontValue" rows="5"
                        (blur)="updateChecklistItem(checklistItem)"
                        style="width:40% !important; word-break:break-word;"></textarea>
              <span>R</span>
              <textarea type="text" pInputText [(ngModel)]="checklistItem.rearValue" rows="5"
                        (blur)="updateChecklistItem(checklistItem)"
                        style="width:40% !important; word-break:break-word;"></textarea>
            </div>
            <div *ngIf="checklistItem.controlType === 'RADIO'" class="front-rear-check">
              <span>F</span>
              <p-radioButton name="{{checklistItem.description}}_F" value="{{'general.yes' | translate}}"
                             label="{{('general.yes' | translate).substring(0,1)}}"
                             [(ngModel)]="checklistItem.frontValue"
                             labelStyleClass="p-radiobutton-label-override"
                             (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
              <p-radioButton name="{{checklistItem.description}}_F" value="{{'general.no' | translate}}"
                             label="{{('general.no' | translate).substring(0,1)}}"
                             [(ngModel)]="checklistItem.frontValue"
                             labelStyleClass="p-radiobutton-label-override"
                             (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
              <p-radioButton name="{{checklistItem.description}}_F"
                             value="{{'general.not_applicable' | translate}}"
                             label="NA" [(ngModel)]="checklistItem.frontValue"
                             labelStyleClass="p-radiobutton-label-override"
                             (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
              <br />
              <span>R</span>
              <p-radioButton name="{{checklistItem.description}}_R" value="{{'general.yes' | translate}}"
                             label="{{('general.yes' | translate).substring(0,1)}}"
                             [(ngModel)]="checklistItem.rearValue"
                             labelStyleClass="p-radiobutton-label-override"
                             (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
              <p-radioButton name="{{checklistItem.description}}_R" value="{{'general.no' | translate}}"
                             label="{{('general.no' | translate).substring(0,1)}}"
                             [(ngModel)]="checklistItem.rearValue"
                             labelStyleClass="p-radiobutton-label-override"
                             (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
              <p-radioButton name="{{checklistItem.description}}_R"
                             value="{{'general.not_applicable' | translate}}"
                             label="NA" [(ngModel)]="checklistItem.rearValue"
                             labelStyleClass="p-radiobutton-label-override"
                             (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
            </div>
            <div *ngIf="checklistItem.controlType === 'TRAFFICLIGHT'" class="front-rear-check">
              <div class="radio-group">


                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.yes' | translate}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               styleClass="red-border"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.no' | translate}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               styleClass="yellow-border"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.not_applicable' | translate}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               styleClass="green-border"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>



                <span style="padding-top:2%">F</span>
                <input type="text" pInputText [(ngModel)]="checklistItem.frontValue" maxlength="1500"
                       (blur)="updateChecklistItem(checklistItem)" />

                <span style="padding-top:2%">R</span>
                <input type="text" pInputText [(ngModel)]="checklistItem.rearValue" maxlength="1500"
                       (blur)="updateChecklistItem(checklistItem)" />

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="details-container margin-top-8" *ngIf="additionalChecklist.length > 0">
  <div>
    <div class="title-flex">
      <div class="checklist-container-header">
        {{
        'bikeshop.modal.update_job_card.checklist.optional_checklist' |
          translate
        }}
      </div>
      <div
        [ngClass]="{ 'hubtiger-arrow-right-small' : additionalChecklistMinimized, 'hubtiger-arrow-down-small' : !additionalChecklistMinimized }"
        (click)="additionalChecklistMinimized = !additionalChecklistMinimized"></div>
    </div>
    <div class="vertical-checklist" [ngClass]="{ 'additional-minimized' : additionalChecklistMinimized }">
      <div *ngFor="let checklistItem of additionalChecklist">
        <div>
          <div class="checklist-label" [ngStyle]="{ 'color': checklistItem.labelColour }">
            {{checklistItem.description}}
          </div>
          <div *ngIf="!checklistItem.frontRearCheck">
            <div *ngIf="checklistItem.controlType === 'CHECKBOX'">
              <p-checkbox [(ngModel)]="checklistItem.defaultValue" [binary]="true"
                          (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
            </div>
            <div *ngIf="checklistItem.controlType === 'TEXT'">
              <input type="text" pInputText [(ngModel)]="checklistItem.defaultValue"
                     (blur)="updateChecklistItem(checklistItem)" style="width:100%" />
            </div>
            <div *ngIf="checklistItem.controlType === 'MULTILINETEXT'">
              <textarea type="text" pInputText [(ngModel)]="checklistItem.defaultValue" rows="5"
                        (blur)="updateChecklistItem(checklistItem)"
                        style="width:100%; word-break:break-word;"></textarea>
            </div>
            <div *ngIf="checklistItem.controlType === 'RADIO'">
              <div>
                <p-radioButton name="{{checklistItem.description}}"
                               value="{{'general.yes' | translate}}"
                               label="{{('general.yes' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}" value="{{'general.no' | translate}}"
                               label="{{('general.no' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}"
                               value="{{'general.not_applicable' | translate}}"
                               label="NA" [(ngModel)]="checklistItem.defaultValue"
                               labelStyleClass="p-radiobutton-label-override"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
              </div>
            </div>
            <div *ngIf="checklistItem.controlType === 'TRAFFICLIGHT'">
              <div class="radio-group">
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.yes' | translate}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               styleClass="red-border"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.no' | translate}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               styleClass="yellow-border"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.not_applicable' | translate}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               styleClass="green-border"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>

                <input type="text" pInputText [(ngModel)]="checklistItem.frontValue" maxlength="1500" style="max-width:163px;min-width:163px"
                       (blur)="updateChecklistItem(checklistItem)" />

              </div>
            </div>
          </div>
          <div *ngIf="checklistItem.frontRearCheck">
            <div *ngIf="checklistItem.controlType === 'CHECKBOX'" class="front-rear-check">
              <span>F</span>
              <p-checkbox [(ngModel)]="checklistItem.frontValue" [binary]="true"
                          (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
              <span>R</span>
              <p-checkbox [(ngModel)]="checklistItem.rearValue" [binary]="true"
                          (onChange)="updateChecklistItem(checklistItem)"></p-checkbox>
            </div>
            <div *ngIf="checklistItem.controlType === 'TEXT'" class="front-rear-check">
              <span>F</span>
              <input type="text" pInputText [(ngModel)]="checklistItem.frontValue"
                     (blur)="updateChecklistItem(checklistItem)" style="width:40% !important" />
              <span>R</span>
              <input type="text" pInputText [(ngModel)]="checklistItem.rearValue"
                     (blur)="updateChecklistItem(checklistItem)" style="width:40% !important" />
            </div>
            <div *ngIf="checklistItem.controlType === 'MULTILINETEXT'" class="front-rear-check">
              <span>F</span>
              <textarea type="text" pInputText [(ngModel)]="checklistItem.frontValue" rows="5"
                        (blur)="updateChecklistItem(checklistItem)"
                        style="width:40% !important; word-break:break-word;"></textarea>
              <span>R</span>
              <textarea type="text" pInputText [(ngModel)]="checklistItem.rearValue" rows="5"
                        (blur)="updateChecklistItem(checklistItem)"
                        style="width:40% !important; word-break:break-word;"></textarea>
            </div>
            <div *ngIf="checklistItem.controlType === 'RADIO'" class="front-rear-check">
              <span>F</span>
              <p-radioButton name="{{checklistItem.description}}_F" value="{{'general.yes' | translate}}"
                             label="{{('general.yes' | translate).substring(0,1)}}"
                             [(ngModel)]="checklistItem.frontValue"
                             labelStyleClass="p-radiobutton-label-override"
                             (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
              <p-radioButton name="{{checklistItem.description}}_F" value="{{'general.no' | translate}}"
                             label="{{('general.no' | translate).substring(0,1)}}"
                             [(ngModel)]="checklistItem.frontValue"
                             labelStyleClass="p-radiobutton-label-override"
                             (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
              <p-radioButton name="{{checklistItem.description}}_F"
                             value="{{'general.not_applicable' | translate}}"
                             label="NA" [(ngModel)]="checklistItem.frontValue"
                             labelStyleClass="p-radiobutton-label-override"
                             (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
              <br />
              <span>R</span>
              <p-radioButton name="{{checklistItem.description}}_R" value="{{'general.yes' | translate}}"
                             label="{{('general.yes' | translate).substring(0,1)}}"
                             [(ngModel)]="checklistItem.rearValue"
                             labelStyleClass="p-radiobutton-label-override"
                             (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
              <p-radioButton name="{{checklistItem.description}}_R" value="{{'general.no' | translate}}"
                             label="{{('general.no' | translate).substring(0,1)}}"
                             [(ngModel)]="checklistItem.rearValue"
                             labelStyleClass="p-radiobutton-label-override"
                             (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
              <p-radioButton name="{{checklistItem.description}}_R"
                             value="{{'general.not_applicable' | translate}}"
                             label="NA" [(ngModel)]="checklistItem.rearValue"
                             labelStyleClass="p-radiobutton-label-override"
                             (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
            </div>
            <div *ngIf="checklistItem.controlType === 'TRAFFICLIGHT'" class="front-rear-check">
              <div class="radio-group">


                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.yes' | translate}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               styleClass="red-border"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.no' | translate}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               styleClass="yellow-border"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.not_applicable' | translate}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               styleClass="green-border"
                               (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>



                <span style="padding-top:2%">F</span>
                <input type="text" pInputText [(ngModel)]="checklistItem.frontValue" maxlength="1500"
                       (blur)="updateChecklistItem(checklistItem)" />

                <span style="padding-top:2%">R</span>
                <input type="text" pInputText [(ngModel)]="checklistItem.rearValue" maxlength="1500"
                       (blur)="updateChecklistItem(checklistItem)" />

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
